(function (Translator) {
    // de
    Translator.add("rate_list.rate.bg_kbcbank", "KBC Bank Betrag", "EvpThemeBundle", "de");
    Translator.add("recaptcha.description", "Diese Nachricht dient dazu, um zu \u00fcberpr\u00fcfen, ob eine Person braust, und \u00dcberpr\u00fcfung durch automatische Systeme zu vermeiden", "EvpThemeBundle", "de");
    Translator.add("recaptcha.title", "Bist du ein Roboter?", "EvpThemeBundle", "de");
})(Translator);
